<template>
  <div class="compressed-content">
    <h3 class="page-question">You indicated that you had a major ASCVD event (heart attack, stroke, unstable angina, bypass, stent, or surgery).<br />Were you on medication to lower your LDL levels when this event happened?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isOnMedicationDuringASCVDToLowerLDL">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.isOnMedicationDuringASCVDToLowerLDL" name="medication"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.isOnMedicationDuringASCVDToLowerLDL" name="medication"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      isOnMedicationDuringASCVDToLowerLDL: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      isOnMedicationDuringASCVDToLowerLDL() { return this.survey.bloodBiochemistry.cholesterol.isOnMedicationDuringASCVDToLowerLDL; }
    }
  };
</script>
